export type SystemCalendarDraft = {
  title: string;
  startDate: Date;
  endDate: Date;
  location?: string;
  notes?: string;
  timeZone?: string;
  scheduleRevision?: number;
};

export type SystemCalendarSyncResult =
  | 'created'
  | 'existing'
  | 'externally-removed'
  | 'externally-changed'
  | 'unavailable'
  | 'permission-required'
  | 'no-writable-calendar';

export type SystemCalendarReconciliation =
  | { state: 'externally-removed' }
  | {
    state: 'externally-changed';
    observedStartDate: string;
    observedEndDate: string;
  };

export type SystemCalendarRemovalResult =
  | 'removed'
  | 'missing'
  | 'unavailable'
  | 'permission-required';

export function buildSystemCalendarDraft(input: {
  title: string;
  proposedAt: string;
  durationMinutes: number;
  location?: string | null;
  notes?: string;
  timeZone?: string | null;
  scheduleRevision?: number;
}): SystemCalendarDraft {
  const startDate = new Date(input.proposedAt);
  const durationMinutes = Number.isFinite(input.durationMinutes)
    ? Math.max(1, input.durationMinutes)
    : 1;
  const endDate = new Date(startDate.getTime() + durationMinutes * 60_000);

  return {
    title: input.title,
    startDate,
    endDate,
    ...(input.location?.trim() ? { location: input.location.trim() } : {}),
    ...(input.notes?.trim() ? { notes: input.notes.trim() } : {}),
    ...(input.timeZone?.trim() ? { timeZone: input.timeZone.trim() } : {}),
    ...(Number.isInteger(input.scheduleRevision) && (input.scheduleRevision ?? 0) >= 0
      ? { scheduleRevision: input.scheduleRevision }
      : {}),
  };
}
